import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartEmptyStateProps } from '../interfaces';

const ShoppingCartEmptyState: React.FC<ShoppingCartEmptyStateProps> = ({
  linkTo = '/products/types/Rings',
}) => (
  <div className="cart-empty-state" role="status">
    <h2>Your cart is empty</h2>
    <p>Add a product before starting checkout.</p>
    <Link to={linkTo} className="cart-empty-state__link">
      Continue shopping
    </Link>
  </div>
);

export default React.memo(ShoppingCartEmptyState);
